import axios from "axios";
import Config from "../common/Config";
import FieldState from "../common/FieldState";
import OrderFormStep from "../common/OrderFormStep";
import FormTitle from "../components/formTitle/FormTitle";
import MuiRadio from "../components/radio/MuiRadio";
import MuiCheckbox from "../components/checkbox/MuiCheckbox";
import InputTextField from "../components/textField/InputTextField";
import Button from "../components/button/Button";
import SecondaryButton from "../components/button/SecondaryButton";
import { CreateNotification } from "../components/notification/Notification";
import SaveAsDraft from "../components/modal/SaveAsDraft";
import ClearOrder from "../components/modal/ClearOrder";
import "react-datepicker/dist/react-datepicker.css";
import {
  Alert,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

export default class FoamCarving extends OrderFormStep {
  constructor(props) {
    super(props);

    this.sendCarvingId = 106;
    this.sendNewCarvingId = 107;
    this.foamCarvingOnlyId = 145;
    this.customerSuppliedPlateId = 50;
    this.customerSuppliedLockId = 43;
    this.customerSuppliedValveId = 58;

    this.nextCartQueueIndex=0;
    this.displayedCartIndex=0;

    this.state = {
      estimatedShipDate: null,
      foamCarvings: [],
      mountingPlates: [],
      isSubmit: false,
      locks: [],
      valves: [],
      materials: [],
      insertMaterials: [],
      formState: {
        foamCarving: new FieldState(true),
        mountingPlate: new FieldState(true),
        lock: new FieldState(true),
        valve: new FieldState(true),
        material: new FieldState(false),
        insertMaterial: new FieldState(false, {}),
        itemsSentIn: new FieldState(false),
        notes: new FieldState(false),
        customerSuppliedPlate: new FieldState(false),
        customerSuppliedLock: new FieldState(false),
        customerSuppliedValve: new FieldState(false),
      },
    };
    this.getNextCartQueueIndex = this.getNextCartQueueIndex.bind(this);
    this.shouldDisplayCart = this.shouldDisplayCart.bind(this);
  }

  getNextCartQueueIndex() {
    return this.nextCartQueueIndex++;
  }

  shouldDisplayCart(index) {
    if(index >= this.displayedCartIndex) {
      this.displayedCartIndex = index;
      return true;
    }

    return false;
  }

  loadCart() {
    let cart = [];

    let addToCart = (options, selectedId, sourceId) => {
      let item = options.filter(x => x.id===selectedId)[0];
      if(item && item.partNumbers && item.partNumbers.length > 0) {
        item.partNumbers.forEach(part => {
          cart.push({
            name: item.displayName,
            partNumber: part,
            quantity: 1,
            price: -1,
            sourceId: sourceId
          });
        });
      } else {
        cart.push({
            name: null,
            partNumber: null,
            quantity: 0,
            price: 0,
            sourceId: sourceId
          });
      }
    }

    addToCart(this.state.foamCarvings, this.state.formState.foamCarving.value, "foamCarving");
    addToCart(this.state.materials, this.state.formState.material.value, "material");
    addToCart(this.state.locks, this.state.formState.lock.value, "lock");
    addToCart(this.state.valves, this.state.formState.valve.value, "valve");
    addToCart(this.state.mountingPlates, this.state.formState.mountingPlate.value, "mountingPlate");

    for (let i = 0; i < this.state.insertMaterials.length; i++) {
      let fieldOptionId = this.state.insertMaterials[i].id;

      if(this.state.formState.insertMaterial.value[fieldOptionId]) {
        addToCart(this.state.insertMaterials, fieldOptionId, ""+fieldOptionId);
      } else {
        addToCart(this.state.insertMaterials, null, ""+fieldOptionId);
      }
    }

    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };
    config.params = {
      cart: cart.map(x => x.partNumber)
    }

    const index = this.getNextCartQueueIndex();

    return this.loadShipDate()
      .then(r1 => {
        return axios.get(
          Config.baseApiUrl + "price/" + this.props.formTypeId,
          config
        ).then(response => {
          let data = response.data
  
          cart = cart.map(c => {
            return {
              key: c.partNumber,
              name: c.name,
              partNumber: c.partNumber,
              quantity: c.quantity,
              price: data.filter(x => x.partNumber === c.partNumber)[0]?.price,
              sourceId: c.sourceId
            }
          });

          cart = cart.concat(data.filter(d => d.sourceId !== null).map(d => {
            return {
              key: d.partNumber,
              name: d.name,
              partNumber: d.partNumber,
              quantity: d.quantity,
              price: d.price,
              sourceId: d.sourceId
            }
          }));
          
          if(this.shouldDisplayCart(index)) {
            this.props.setTempCart(cart);
          }
        }).catch(error =>{
          console.log(error)
        })
      });
  }

  checkThermolynData() {
    let formState = this.state.formState;
    
    formState.mountingPlate.isRequired = formState.material.value !== 105;

    if(!formState.mountingPlate.isRequired) {
      formState.mountingPlate.value = null;
    }

    this.setState({
      formState: formState,
    });
  }

  checkCarvingData() {
    let formState = this.state.formState;

    let isCarvingOnly = formState.foamCarving.value === this.foamCarvingOnlyId
    formState.material.isRequired = !isCarvingOnly;
    formState.lock.isRequired = !isCarvingOnly;
    formState.valve.isRequired = !isCarvingOnly;
    formState.mountingPlate.isRequired = !isCarvingOnly && formState.material.value !== 105;

    if(isCarvingOnly) {
      formState.material.value = null;
      formState.lock.value = null;
      formState.valve.value = null;
      formState.mountingPlate.value = null;
    }

    this.setState({
      formState: formState,
    });
  }

  componentDidMount() {
    this.loadData();
  }

  async loadShipDate() {
    try {
      let config = {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token"))?.access_token,
        },
      };
      let estimatedShipDate = (
        await axios.get(
          Config.baseApiUrl + "shipDate/" + this.props.formTypeId,
          config
        )
      ).data;

      this.setState({
        estimatedShipDate: estimatedShipDate,
      });
    } catch (error) {
      //   this.props.handleError(new LoadFailureResult());
    }
    this.setState({ isLoaded: true });
  }

  async loadData() {
    try {
      this.setState({
        foamCarvings: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "foamCarving" },
            }
          )
        ).data,
        mountingPlates: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "mountingPlate" },
            }
          )
        ).data,

        locks: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "lock" },
            }
          )
        ).data,
        valves: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "valve" },
            }
          )
        ).data,
        materials: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "material" },
            }
          )
        ).data,
        insertMaterials: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "insertMaterial" },
            }
          )
        ).data,
        estimatedShipDate: this.state.estimatedShipDate,
      });
      this.loadShipDate();
      let config = {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
        },
        params: {
          fieldNames: [
            "foamCarving",
            "mountingPlate",
            "lock",
            "valve",
            "material",
            "insertMaterial",
            "itemsSentIn",
            "notes",
            "customerSuppliedPlate",
            "customerSuppliedLock",
            "customerSuppliedValve",
          ],
        },
      };

      const { data } = await axios.get(
        Config.baseApiUrl + "fieldInputs/" + this.props.formTypeId,
        config
      );
      let formState = this.state.formState;
      formState.foamCarving.value = data.find(
        (fi) => fi.fieldName === "foamCarving"
      ).fieldOptionId;

      formState.mountingPlate.value = data.find(
        (fi) => fi.fieldName === "mountingPlate"
      ).fieldOptionId;

      formState.lock.value = data.find(
        (fi) => fi.fieldName === "lock"
      ).fieldOptionId;

      formState.valve.value = data.find(
        (fi) => fi.fieldName === "valve"
      ).fieldOptionId;

      formState.customerSuppliedPlate.value = data.find(
        (fi) => fi.fieldName === "customerSuppliedPlate"
      ).stringData;

      formState.customerSuppliedLock.value = data.find(
        (fi) => fi.fieldName === "customerSuppliedLock"
      ).stringData;

      formState.customerSuppliedValve.value = data.find(
        (fi) => fi.fieldName === "customerSuppliedValve"
      ).stringData;

      formState.material.value = data.find(
        (fi) => fi.fieldName === "material"
      ).fieldOptionId;

      formState.itemsSentIn.value = data.find(
        (fi) => fi.fieldName === "itemsSentIn"
      ).stringData;

      formState.notes.value = data.find(
        (fi) => fi.fieldName === "notes"
      ).stringData;

      for (let i = 0; i < this.state.insertMaterials.length; i++) {
        let fieldOptionId = this.state.insertMaterials[i].id;
        let fieldInput = data.find(
          (fi) =>
            fi.fieldName === "insertMaterial" &&
            fi.fieldOptionId === fieldOptionId
        );

        if (fieldInput !== undefined) {
          formState.insertMaterial.value[fieldOptionId] =
            fieldInput.booleanData;
        } else {
          formState.insertMaterial.value[fieldOptionId] = false;
        }
      }

      this.setState({
        formState: formState,
      });

      this.checkCarvingData();
      this.checkThermolynData();

      this.loadCart();
      this.getFormSteps();
    } catch (error) {
      // this.props.handleError(new LoadFailureResult());
    }

    this.setState({ isLoaded: true });
  }

  getFieldInputPromise() {
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    let data = [];
    // let notes = { data: this.state.formState.notes.value };

    let isCarvingOnly = this.state.formState.foamCarving.value === this.foamCarvingOnlyId

    data.push({
      fieldName: "foamCarving",
      fieldOptionId: this.state.formState.foamCarving.value,
    });


    if(!isCarvingOnly) {
      data.push({
        fieldName: "material",
        fieldOptionId: this.state.formState.material.value,
      });
        
      if(this.state.formState.mountingPlate.isRequired) {
        data.push({
          fieldName: "mountingPlate",
          fieldOptionId: this.state.formState.mountingPlate.value,
        });
      } else {
        data.push({
          fieldName: "mountingPlate",
          fieldOptionId: null,
        });
      }

      data.push({
        fieldName: "lock",
        fieldOptionId: this.state.formState.lock.value,
      });

      data.push({
        fieldName: "valve",
        fieldOptionId: this.state.formState.valve.value,
      });

    } else {
      data.push({
        fieldName: "material",
        fieldOptionId: null,
      });

      data.push({
        fieldName: "mountingPlate",
        fieldOptionId: null,
      });

      data.push({
        fieldName: "lock",
        fieldOptionId: null,
      });

      data.push({
        fieldName: "valve",
        fieldOptionId: null,
      });
    }

    data.push({
      fieldName: "itemsSentIn",
      stringData: this.state.formState.itemsSentIn.value,
    });

    data.push({
      fieldName: "notes",
      stringData: this.state.formState.notes.value,
    });

    for (let i = 0; i < this.state.insertMaterials.length; i++) {
      let fieldOptionId = this.state.insertMaterials[i].id;

      data.push({
        fieldName: "insertMaterial",
        fieldOptionId: fieldOptionId,
        booleanData: this.state.formState.insertMaterial.value[fieldOptionId] && !isCarvingOnly,
      });
    }
    
    data.push({
      fieldName: "customerSuppliedPlate",
      stringData: this.state.formState.mountingPlate.value === this.customerSuppliedPlateId
        ? this.state.formState.customerSuppliedPlate.value
        : null,
    });

    data.push({
      fieldName: "customerSuppliedLock",
      stringData: this.state.formState.lock.value === this.customerSuppliedLockId
        ? this.state.formState.customerSuppliedLock.value
        : null,
    });

    data.push({
      fieldName: "customerSuppliedValve",
      stringData: this.state.formState.valve.value === this.customerSuppliedValveId
        ? this.state.formState.customerSuppliedValve.value
        : null,
    });

    return axios.post(
      Config.baseApiUrl + "fieldInputs/" + this.props.formTypeId,
      data,
      config
    )
  }

  saveData() {
    this.checkThermolynData();
    this.checkCarvingData();

    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    if (this.validateData().isValid) {
      return this.getFieldInputPromise();
    } else {
      this.setState({
        isSubmit: true,
      });
      CreateNotification(this.validateData().errorMessage, "error");

      return null;
    }
  }

  formatShipDate(shipDate) {
    if (!shipDate) {
      return "";
    }
    return `${shipDate.month}/${shipDate.day}/${shipDate.year}`;
  }

  handleError(id) {
    const { formState } = this.state;
    const errorClass =
      formState[id].isRequired &&
      (formState[id].value === "" ||
        formState[id].value === 0 ||
        formState[id].value === null);
    return errorClass ? true : false;
  }

  convertToISOString(dateString) {
    const dateParts = dateString.split("-");
    const convertedDate = new Date(
      dateParts[0],
      dateParts[1] - 1,
      dateParts[2]
    );

    return convertedDate;
  }
  formatDateToString(date) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  getFormSteps() {
    if (!this.state.formState.mountingPlate.isRequired) {
      this.props.getFormSteps([4]);
    } else {
      this.props.getFormSteps();
    }
  }

  render() {
    if (!this.state.isLoaded) return this.makeLoadingText();

    this.state.foamCarvings.forEach((element) => {
      if (element.id === this.sendCarvingId) {
        element.suffix = ["(if possible - no charge)"];
      } else if (element.id === this.sendNewCarvingId) {
        element.suffix = [
          "(if original carving is unsalvageable)",
        ];
      } else {
        element.suffix = [];
      }
    });

    return (
      <>
        <div className="checkFormWrapper">
          <FormTitle
            title="Product Information"
            description=""
          />

          <form className="checkform" onSubmit={e => {e.preventDefault()}}>
            <div className="fieldBorder">
              <MuiRadio
                options={this.state.foamCarvings}
                defaultValue={this.state.formState.foamCarving.value}
                label="Foam Carving"
                required={this.state.formState["foamCarving"].isRequired}
                error={this.handleError("foamCarving") && this.state.isSubmit}
                checked
                onChange={(e) => {
                  this.props.setActiveInnerStep(1);
                  this.onRadioChange(e, "foamCarving");
                  this.checkCarvingData();
                }}
              />
            </div>
            {this.state.formState.foamCarving.value !== this.foamCarvingOnlyId && (
              <><div className="fieldBorder">
                <MuiRadio
                  options={this.state.materials}
                  label="Socket Material"
                  checked
                  required={this.state.formState["material"].isRequired}
                  defaultValue={this.state.formState.material.value}
                  error={this.handleError("material") && this.state.isSubmit}
                  onChange={(e) => {
                    this.props.setActiveInnerStep(2);
                    this.onRadioChange(e, "material");
                    this.checkThermolynData();
                    this.getFormSteps();
                  }}
                />
              </div>
              <div className="fieldBorder">
              <h4 className="headLable">Suspension</h4>
              <MuiRadio
                options={this.state.locks}
                defaultValue={this.state.formState.lock.value}
                label="Lock"
                required={this.state.formState["lock"].isRequired}
                error={this.handleError("lock") && this.state.isSubmit}
                checked
                onChange={(e) => {
                  this.props.setActiveInnerStep(3);
                  this.onRadioChange(e, "lock");
                }}
                onInputChange={this.onInputChange}
                customerSuppliedField={"customerSuppliedLock"}
                customerSuppliedFieldValue={this.state.formState.customerSuppliedLock.value}
                setActiveInnerStep={this.props.setActiveInnerStep}
                activeInnerStep={3}
              />

              <MuiRadio
                options={this.state.valves}
                defaultValue={this.state.formState.valve.value}
                label="Valve"
                required={this.state.formState["valve"].isRequired}
                error={this.handleError("valve") && this.state.isSubmit}
                onChange={(e) => {
                  this.props.setActiveInnerStep(3);
                  this.onRadioChange(e, "valve");
                }}
                onInputChange={this.onInputChange}
                customerSuppliedField={"customerSuppliedValve"}
                customerSuppliedFieldValue={this.state.formState.customerSuppliedValve.value}
                setActiveInnerStep={this.props.setActiveInnerStep}
                activeInnerStep={3}
              />
            </div>

            {this.state.formState.mountingPlate.isRequired && (
              <div className="fieldBorder">
                <div className="radioGroup">
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      value={this.state.formState.mountingPlate.value}
                      defaultValue={this.state.formState.mountingPlate.value}
                      onChange={(e) => {
                        this.props.setActiveInnerStep(4);
                        this.onRadioChange(e, "mountingPlate");
                      }}
                      name="radio-buttons-group"
                      row
                    >
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <FormLabel id="demo-radio-buttons-group-label">
                          Mounting Plate{" "}
                          {this.state.formState["mountingPlate"].isRequired ? (
                            <span style={{ color: "red" }}>*</span>
                          ) : (
                            ""
                          )}
                        </FormLabel>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "start",
                            flexWrap: "wrap",
                            gap: "16px",
                          }}
                        >
                          {this.state.mountingPlates
                            .filter(
                              (plate) => !plate.displayName.includes("Prong")
                            )
                            .map((plate) => (
                              <div>
                                <FormControlLabel
                                key={plate.id}
                                  value={plate.id}
                                  control={<Radio />}
                                  label={
                                    <div className="radioLabel">
                                      <div className="radioIcon">
                                        <span>{plate.displayName}</span>
                                      </div>

                                    </div>
                                  }
                                  className={`${parseInt(this.selectedValue) === plate.id
                                      ? "checkedLabel"
                                      : this.state.formState.mountingPlate
                                        .value === plate.id
                                        ? "checkedLabel"
                                        : ""
                                    }`}
                                />
                                {(plate.id ===
                                  this.customerSuppliedPlateId &&
                                  this.state.formState.mountingPlate.value ===
                                  this.customerSuppliedPlateId) ?
                                  <div className="radioGroup mt-3">
                                    <div className="radioLabel">
                                      <InputTextField
                                        label={plate.displayName + " Name"}
                                        variant="outlined"
                                        placeholder={"Plate"}
                                        type="text"
                                        required={false}
                                        value={this.state.formState.customerSuppliedPlate.value}
                                        fullWidth={true}
                                        onChange={(e) => {
                                          this.props.setActiveInnerStep(4);
                                          this.onInputChange(e, "customerSuppliedPlate")
                                        }}
                                      />
                                    </div>
                                  </div>
                                  : <></>}
                              </div>
                            ))}
                        </div>
                      </div>

                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <FormLabel id="demo-radio-buttons-group-label">
                          WW SS 3-Prong
                        </FormLabel>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            flexWrap: "wrap",
                            gap: "16px",
                          }}
                        >
                          {this.state.mountingPlates
                            .filter((plate) =>
                              plate.displayName.includes("Prong")
                            )
                            .map((plate) => (
                              <FormControlLabel
                                key={plate.id}
                                value={plate.id}
                                control={<Radio />}
                                label={
                                  <div className="radioLabel">
                                    <div className="radioIcon">
                                      <span>{plate.displayName}</span>
                                    </div>
                                  </div>
                                }
                                className={`${
                                  parseInt(this.selectedValue) === plate.id
                                    ? "checkedLabel"
                                    : this.state.formState.mountingPlate
                                        .value === plate.id
                                    ? "checkedLabel"
                                    : ""
                                }`}
                              />
                            ))}
                          {this.handleError("mountingPlate") &&
                            this.state.isSubmit && (
                              <Alert
                                severity="error"
                                style={{
                                  padding: "0px 16px",
                                  marginTop: "12px",
                                }}
                              >
                                Select an option
                              </Alert>
                            )}
                        </div>
                      </div>
                    </RadioGroup>
                  </FormControl>
                </div>
              </div>
            )}

            <div className="fieldBorder">
              <MuiCheckbox
                checkboxes={this.state.insertMaterials}
                boxLabel="Insert Material"
                defaultValue={this.state.formState.insertMaterial.value}
                required={this.state.formState["insertMaterial"].isRequired}
                error={
                  this.handleError("insertMaterial") && this.state.isSubmit
                }
                checked
                onChange={(e, id) => {
                  this.props.setActiveInnerStep(5);
                  this.onCheckboxChange(e, id, "insertMaterial");
                }}
              />
            </div>
              </>
            )}

            <div className="msgBox fieldBorder msgBoxWidth">
              <div className="possibelDate">
              <div>
                  <h4 className="headLable"><b>Earliest Ship Date</b>: {this.formatShipDate(this.state.estimatedShipDate)}</h4>
                </div>
              </div>
              <InputTextField
                label="Items sent in with socket"
                variant="outlined"
                placeholder="Type Something here..."
                type="text"
                width="800px"
                multiline
                rows={6}
                value={this.state.formState.itemsSentIn.value}
                error={this.handleError("itemsSentIn") && this.state.isSubmit}
                required={this.state.formState["itemsSentIn"].isRequired}
                onChange={(e) => {
                  this.props.setActiveInnerStep(6);
                  this.onInputChange(e, "itemsSentIn");
                }}
              />
            </div>

            <div className="msgBox msgBoxWidth">
              <h4 className="headLable">Notes</h4>
              <InputTextField
                label="Other Notes"
                variant="outlined"
                placeholder="Type Something here..."
                type="text"
                width="800px"
                multiline
                value={this.state.formState.notes.value}
                error={this.handleError("notes") && this.state.isSubmit}
                rows={6}
                onChange={(e) => {
                  this.props.setActiveInnerStep(7);
                  this.onInputChange(e, "notes");
                }}
              />
            </div>
          </form>
        </div>

        <div className="handelButtons">
          <SecondaryButton
            text="Save As Draft"
            onClick={this.props.handleClickOpen}
          />
          <SecondaryButton
            text = "Clear the Order?"
            onClick = {this.props.handleClickClearOpen}
          />
          <div className="stepBtn">
            <SecondaryButton
              text="Back"
              onClick={() => this.props.handleBack(this.props.currentIndex - 1)}
              disabled={
                this.props.activeOuterStep === 0 && this.props.innerStep === 0
              }
            />
            <Button
              text="Next"
              disabled={this.state.isLoading}
              onClick={async () => {
                try {
                  this.setState({ isLoading: true });
                  const res = await this.saveData();
                  if (res.status === 204) {
                    this.props.handleNext(3);
                    this.setState({ isLoading: false });
                  }
                } catch (err) {
                  this.setState({ isLoading: false });
                }
              }}
            />
          </div>
        </div>
        <SaveAsDraft
          open={this.props.open}
          handleClose={this.props.handleClose}
          showSubmit={this.props.showSubmit}
          setShowSubmit={this.props.setShowSubmit}
        />
        <ClearOrder
          openClear={this.props.openClear}
          handleCloseClear={this.props.handleCloseClear}
          showClear={this.props.showClear}
          setShowClear={this.props.setShowClear}
          formId = {this.props.formTypeId}
          handleClearBack={this.props.handleClearBack}
        />
      </>
    );
  }
}
